export const COMPANY_NAME = 'RaooSastro'
export const hosturl = `https://api.raoosastro.com`
// export const hosturl = `https://localhost:4200`

export const COLORS = {
    primary: '#7E87F1',
    secondary: 'darkred',
    third: '#203251',
    forth: "#133822"
}


// #203251
// #000000
// #ffffff